import { Skeleton, Flex } from '@mantine/core';
import { DashedBox, InnerBox, FooterWrapper } from './styled';

export const MultiFileDropZoneSkeleton = () => {
	return (
		<DashedBox>
			<InnerBox>
				<Skeleton height={40} width={40} circle mb="sm" />
				<div>
					<Flex direction="row" gap={2} align="center">
						<Skeleton color="red" height={16} width={80} />
						<Skeleton height={14} width={120} ml={4} />
					</Flex>
					<Skeleton height={14} width="60%" mt={8} />
				</div>
			</InnerBox>
			<FooterWrapper>
				<Skeleton height={12} width="40%" />
			</FooterWrapper>
		</DashedBox>
	);
};
